import { iapVerifier } from '@/api/pay';

function setupWebViewJavascriptBridge(callback) {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios 终端
  
  if (isAndroid) {
    if (window.WebViewJavascriptBridge) {
      callback(window.WebViewJavascriptBridge);
    } else {
      document.addEventListener(
        "WebViewJavascriptBridgeReady",
        function() {
          callback(window.WebViewJavascriptBridge);
        },
        false
      );
    }
  } else if (isiOS) {
    // iOS支持webkit.messageHandlers
    if (window.webkit && window.webkit.messageHandlers) {
      // 创建兼容的bridge对象
      const iosBridge = {
        callHandler: function(handlerName, data, callback) {
          if (window.webkit.messageHandlers[handlerName]) {
            window.webkit.messageHandlers[handlerName].postMessage(data);
            if (callback) {
              // 对于iOS，我们可能需要通过其他方式处理回调
              setTimeout(callback, 100);
            }
          } else {
            console.warn(`Handler ${handlerName} not found in webkit.messageHandlers`);
          }
        },
        registerHandler: function(handlerName, callback) {
          // 将回调函数存储到全局对象中，供iOS调用
          if (!window.iosCallbacks) {
            window.iosCallbacks = {};
          }
          window.iosCallbacks[handlerName] = callback;
        },
        init: function(callback) {
          if (callback) callback();
        }
      };
      callback(iosBridge);
    } else if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge);
    } else if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    } else {
      window.WVJBCallbacks = [callback];
      let WVJBIframe = document.createElement("iframe");
      WVJBIframe.style.display = "none";
      WVJBIframe.src = "https://__bridge_loaded__";
      document.documentElement.appendChild(WVJBIframe);
      setTimeout(function() {
        document.documentElement.removeChild(WVJBIframe);
      }, 0);
    }
  } else {
    if (window.WebViewJavascriptBridge) {
      
      return callback(window.WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    let WVJBIframe = document.createElement("iframe");
    WVJBIframe.style.display = "none";
    WVJBIframe.src = "https://__bridge_loaded__";
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function() {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
  }
}

export const callhandler = function(name, data, callback) {
  setupWebViewJavascriptBridge(function(bridge) {
    bridge.callHandler(name, data, callback);
  });
};

export const registerHandler = function(name, callback) {
  setupWebViewJavascriptBridge(function(bridge) {
    bridge.registerHandler(name, function(data, responseCallback) {
      callback(data, responseCallback);
    });
  });
};

// android需要
export const inithandler = function() {
  setupWebViewJavascriptBridge(function(bridge) {
    bridge.init(function () {});
  });
};

// 新增：直接调用webkit.messageHandlers的方法（用于miracles相关功能）
export const callWebkitHandler = function(handlerName, data) {
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[handlerName]) {
    window.webkit.messageHandlers[handlerName].postMessage(data);
  } else {
    console.warn(`webkit.messageHandlers.${handlerName} not available`);
  }
};

// 新增：注册iOS回调函数（供iOS调用）
export const registerIosCallback = function(handlerName, callback) {
  if (!window.iosCallbacks) {
    window.iosCallbacks = {};
  }
  window.iosCallbacks[handlerName] = callback;
};

// 新增：供iOS调用的全局函数
window.miraclesResponse = async function(data) {
  console.log('miraclesResponse called with data:', data);
  
  try {
    // 检查数据格式
    if (!data || !data.identifier || !data.order) {
      console.error('miraclesResponse: 缺少必要参数', data);
      return;
    }
    
    const { identifier, order } = data;
    // 调用 iapVerifier 验证内购凭据
    const result = await iapVerifier({
      receipt: identifier,
      order_sn: order
    });
    // 处理验证结果
    if (result && result.ret === 1) {
      console.log('内购验证成功');
      
      try {
        if (window.store) {
          window.store.dispatch('pay/queryOrderResult', { root: true });
        } else {
          console.error('window.store 未定义');
        }
      } catch (queryError) {
        console.warn('触发支付成功逻辑失败:', queryError);
      }
      
    } else {
      console.error('内购验证失败:', result);
      
    }
  } catch (error) {
    console.error('内购验证异常:', error);
  }};
